// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__1szGY"};